import { AppDispatch } from '@/configureStore';
import { gmtEnhancedConversionAction } from '@/stores/gmt/cart/actionCreators';
import { dispatchQueuedActions } from '@/stores/redux-action-queue-middleware';
import { GTM_QUEUE_STORAGE_KEY } from '@constants/constants';

declare global {
  interface Window {
    Cookiebot?: { consent: { marketing: boolean } };
  }
}

const hasMarketingConsent = () => typeof window !== 'undefined' && window.Cookiebot?.consent?.marketing === true;

export const sendEnhancedConversion = (email: string, dispatch: AppDispatch) => {
  if (!email) {
    return;
  }

  dispatch({
    ...gmtEnhancedConversionAction(email),
    meta: { queue: !hasMarketingConsent(), preventDispatch: !hasMarketingConsent() }
  });
};

export const registerCookiebotFlush = (dispatch: AppDispatch) => {
  const flush = () => {
    if (hasMarketingConsent()) {
      dispatchQueuedActions(dispatch, GTM_QUEUE_STORAGE_KEY);
    }
  };

  if (typeof window !== 'undefined') {
    flush();
    window.addEventListener('CookiebotOnConsentReady', flush);
    window.addEventListener('CookiebotOnConsentUpdate', flush);
  }
};
